import {useTranslation} from 'react-i18next';
import AppTextInput from '../../../../../../../components/common/AppTextInput';

function ShortAnswerField() {
  const {t} = useTranslation();

  return (
    <div>
      <AppTextInput
        placeholder={t('forms.dialog.shortAnswerPlaceholder')}
        className="border-none"
        disabled
      />
    </div>
  );
}

export default ShortAnswerField;
